// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3uMto","name":"ConsentHeader_name__3U9aL","birthday":"ConsentHeader_birthday__qghbd","skeleton":"ConsentHeader_skeleton__3SxAJ"};